export const businessCreditCardsCategory = 'businessCreditCards';
export const personalCreditCardCategory = 'personalCreditCards';
export const businessLoansCategory = 'businessLoans';
export const businessCheckingCategory = 'businessChecking';
export const businessTaxesCategory = 'businessTaxes';
export const businessInsuranceCategory = 'businessInsurance';
export const merchantServicesCategory = 'merchantServices';
export const businessFormationCategory = 'businessFormation';
export const payrollServicesCategory = 'payroll';
export const accountingServicesCategory = 'accounting';
export const businessCreditCardsSlug = 'business-credit-cards';
export const businessLoansSlug = 'business-loans';
export const businessCheckingSlug = 'business-checking';
export const businessTaxesSlug = 'business-taxes';
export const businessInsuranceSlug = 'business-insurance';
export const merchantServicesSlug = 'business-formation';
export const businessFormationSlug = 'merchant-services';
export const payrollServicesSlug = 'payroll-services';
export const accountingServicesSlug = 'accounting-services';
// maps the camel case category key to the URL slug path for a category
export const marketplaceCategoryKeyToSlugMap = {
    [businessCreditCardsCategory]: businessCreditCardsSlug,
    [businessLoansCategory]: businessLoansSlug,
    [businessCheckingCategory]: businessCheckingSlug,
    [businessTaxesCategory]: businessTaxesSlug,
    [businessInsuranceCategory]: businessInsuranceSlug,
    [merchantServicesCategory]: merchantServicesSlug,
    [businessFormationCategory]: businessFormationSlug,
    [payrollServicesCategory]: payrollServicesSlug,
    [accountingServicesCategory]: accountingServicesSlug,
};
// maps the URL slug paths to the camel case category key
export const marketplaceCategorySlugToKeyMap = Object.keys(marketplaceCategoryKeyToSlugMap).reduce((result, category) => {
    const slug = marketplaceCategoryKeyToSlugMap[category];
    result[slug] = category;
    return result;
}, {});
//# sourceMappingURL=marketplace-offer-category.js.map